import React, { useEffect, useState } from "react";
import { IoArrowBack, IoClose } from "react-icons/io5";
import CuDropdown from "../../common_component/component/CuDropdown";
import { MdNavigateNext } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Medicine from "../components/Medicine";
import { GiAlarmClock } from "react-icons/gi";
import { PiForkKnife } from "react-icons/pi";
import { BsCapsule } from "react-icons/bs";
import { FiPlus } from "react-icons/fi";
import { IoIosCheckmarkCircle } from "react-icons/io";
import CuMobileModal from "../../all-patient/components/CuMobileModal";
import MedicineDetails from "./MedicineDetails";

const MedicineComponent = ({
  setIsSuggestion,
  medicineData,
  setMedicineData,
}) => {
  // Function to remove the medicine
  const handleRemoveMedicine = (id) => {
    // Filter out the medicine from medicineData array
    setMedicineData((prevMedicineData) =>
      prevMedicineData.filter((medicine) => medicine.id !== id)
    );
  };

  useEffect(() => {
    // Filter out empty objects based on specific criteria

    //("runned");
    const filteredMedicineData = medicineData?.filter((medicine) => {
      return medicine.medicineName !== "";
    });

    // Set filtered data to medicineData
    setMedicineData(filteredMedicineData);
    // //("medicineData", filteredMedicineData);
  }, []);

  return (
    <div className="mt-[90px]">
      <div className="w-full px-4">
        <div className="w-full h-[53px] border rounded overflow-hidden">
          <input
            className="w-full h-full outline-none pl-4 bg-[#F6F6F6]"
            placeholder="Search Medicine"
            type="search"
            onClick={() => setIsSuggestion(true)}
          />
        </div>

        {medicineData?.map((ele) => {
          return (
            <div className="w-full flex justify-between my-2 ">
              <div className="mb-2">
                <div className=" w-[226px] flex items-center justify-between text-sm">
                  <div className="text-[#393939]">{ele?.medicineName}</div>
                  {/* <div>1-0-1</div> */}
                </div>
                <div className="flex items-center gap-6 mt-1">
                  <div className="flex items-center gap-2">
                    <GiAlarmClock color="#3DBA7C" size={10} />{" "}
                    <span className="text-[#6B6B6B] text-xs">
                      {ele?.duration}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <PiForkKnife color="#F55301" size={10} />{" "}
                    <span className="text-[#6B6B6B] text-xs">
                      {ele?.when?.name}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <BsCapsule color="#E7267A" size={10} />{" "}
                    <span className="text-[#6B6B6B] text-xs">
                      {ele?.dosage?.name}
                    </span>
                  </div>
                </div>
              </div>
              {/* Remove medicine on click */}
              <span onClick={() => handleRemoveMedicine(ele?.id)}>
                <IoClose size={22} color="#393939" />
              </span>
            </div>
          );
        })}
      </div>
      {/* <div className="absolute bottom-4 w-full px-4 flex justify-between gap-4">
        <button className="h-[55px] rounded text-[#575757] flex-1 border">
          Preview
        </button>
        <button className="h-[55px] bg-[#C7EAC9] rounded text-[#575757] flex-1 flex border justify-center items-center">
          Advice{" "}
          <span>
            <MdNavigateNext size={20} />
          </span>
        </button>
      </div> */}
      {/* <CuMobileModal
        modalClassName="medicine-prescription"
        isOpen={openMedicineModal}
        closeModal={() => setOpenMedicineModal(false)}
      >
        <MedicineDetails />
      </CuMobileModal> */}
    </div>
  );
};

export default MedicineComponent;
